module.exports = "https://ssr-releases-cdn.paperlesspost.com/_next/static/images/tile_springparties-0085cb96812f7d367f5d06405c30c081.jpg";